const openingHours = [
  { day: 'Ponedeljek', jsDay: 1, hours: '6:30 – 23:00', closed: false },
  { day: 'Torek', jsDay: 2, hours: '6:30 – 23:00', closed: false },
  { day: 'Sreda', jsDay: 3, hours: '6:30 – 23:00', closed: false },
  { day: 'Četrtek', jsDay: 4, hours: '6:30 – 23:00', closed: false },
  { day: 'Petek', jsDay: 5, hours: '6:30 – 1:00', closed: false },
  { day: 'Sobota', jsDay: 6, hours: '6:30 – 1:00', closed: false },
  { day: 'Nedelja', jsDay: 0, hours: 'ZAPRTO', closed: true },
];

export default function OpeningHoursSection() {
  const today = new Date().getDay();

  return (
    <section id="delovni-cas" className="relative bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
              ODPIRALNI ČAS
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-3">
              Kdaj nas lahko obiščeš?
            </h2>
            <p className="font-body text-sm md:text-base text-foreground-600">
              Odprti smo vse dni v tednu – razen nedelje.
            </p>
          </div>

          <div className="bg-background-100 border border-background-200/70 rounded-lg overflow-hidden">
            {openingHours.map((item, idx) => {
              const isToday = item.jsDay === today;
              return (
                <div
                  key={item.day}
                  className={`flex items-center justify-between gap-4 px-5 md:px-8 py-4 md:py-5 transition-colors duration-300 ${
                    idx !== openingHours.length - 1 ? 'border-b border-background-200/70' : ''
                  } ${isToday ? 'bg-accent-500/8' : ''}`}
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <span
                      className={`w-2 h-2 rounded-full flex-shrink-0 ${
                        isToday ? 'bg-accent-500' : 'bg-background-300'
                      }`}
                    ></span>
                    <span
                      className={`font-label text-sm md:text-base tracking-wide ${
                        isToday ? 'text-foreground-950 font-semibold' : 'text-foreground-800 font-medium'
                      }`}
                    >
                      {item.day}
                    </span>
                    {isToday && (
                      <span className="hidden sm:inline-block font-label text-[10px] tracking-extra-wide uppercase text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                        Danes
                      </span>
                    )}
                  </div>
                  <span
                    className={`font-body text-sm md:text-base tabular-nums whitespace-nowrap ${
                      item.closed
                        ? 'text-accent-600 font-semibold uppercase tracking-wide'
                        : isToday
                          ? 'text-foreground-950 font-semibold'
                          : 'text-foreground-600'
                    }`}
                  >
                    {item.hours}
                  </span>
                </div>
              );
            })}
          </div>

          <p className="font-body text-xs md:text-sm text-foreground-500 text-center mt-6">
            Na praznike so ure lahko prilagojene. Za točen termin nas pokliči.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <a
              href="tel:+38627130060"
              className="inline-flex items-center gap-3 w-full sm:w-auto px-6 py-3.5 sm:py-3 bg-background-100 hover:bg-background-200/80 border border-background-200/70 hover:border-accent-300/50 rounded-md transition-all duration-300 cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/12 text-accent-600">
                <i className="ri-phone-line"></i>
              </span>
              <span className="flex flex-col leading-tight text-left">
                <span className="font-body text-sm md:text-base text-foreground-900 font-medium whitespace-nowrap">02 713 00 60</span>
                <span className="font-label text-[10px] tracking-extra-wide uppercase text-foreground-500">Glavna številka</span>
              </span>
            </a>
            <a
              href="tel:+38641331990"
              className="inline-flex items-center gap-3 w-full sm:w-auto px-6 py-3.5 sm:py-3 bg-background-100 hover:bg-background-200/80 border border-background-200/70 hover:border-accent-300/50 rounded-md transition-all duration-300 cursor-pointer"
            >
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/12 text-accent-600">
                <i className="ri-smartphone-line"></i>
              </span>
              <span className="flex flex-col leading-tight text-left">
                <span className="font-body text-sm md:text-base text-foreground-900 font-medium whitespace-nowrap">041 331 990</span>
                <span className="font-label text-[10px] tracking-extra-wide uppercase text-foreground-500">Mobilna številka</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}